import { modalVariants } from '@/app/[locale]/(main)/profile/_components/ProfilePredictionDialog/staticStyles';
import { normalizeTokenSymbol } from '@/lib/utils/pools';
import { T_VariantType } from '@/ts/types/T_VariantType';

export const getVariantFromTokenSymbol = (
  selectedParticipation:
    | {
        predictionEvent: {
          tokenSymbol: string;
        };
      }
    | null
    | undefined,
  variant?: T_VariantType
): T_VariantType => {
  if (selectedParticipation?.predictionEvent?.tokenSymbol) {
    const normalized = normalizeTokenSymbol(
      selectedParticipation.predictionEvent.tokenSymbol
    ).toUpperCase();
    const variantMap: Record<string, T_VariantType> = {
      BTC: 'BTC',
      ETH: 'ETH',
      SOL: 'SOL',
      XRP: 'XRP'
    };
    return variantMap[normalized] || 'BTC';
  }
  return variant && modalVariants[variant] ? variant : 'BTC';
};
